import React from 'react';
import T from 'prop-types';
import { Title } from '../../atoms';

export const PrintHeader = ({ title, orderNumber, dateToday }) => {
    return <div className="printHeader">
        <Title text={title} className={'printTitle'} />
        <div className="printRow">
            <Title text={`Order #${orderNumber}`} />
            <Title text={dateToday} />
        </div>
    </div>;
};

PrintHeader.T = {
    title: T.string,
    orderNumber: T.string,
    dateToday: T.string
};
